import { popToMainLayer } from './angular-bridge';

/**
 * Navigate to an Angular route (hash-bang style).
 *
 * Also drops any layer stacked above 'main' (search, resource). Angular's own links
 * did this — `iio-href layer="main"` pops to main on click — so without it a React
 * link fired from inside the search layer changes the route behind a layer that stays
 * on top, and nothing appears to happen.
 */
export function navigateToAngular(path: string, { replace = false } = {}): void {
  popToMainLayer();
  if (replace) window.location.replace(`#!${path}`);
  else window.location.hash = `!${path}`;
}
